import { useEffect } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { RadioButtonGroupInput, CheckboxGroupInput, BooleanInput, useRecordContext } from 'react-admin';
import {
  MCP_WRITE_MODES,
  MCP_WRITE_MODE_CHOICES,
  MCP_APPROVER_ROLES
} from '../../../../../config/constants/mcpPermissionsConstants';

export const McpPermissionsTab = ({ tables }) => {
  const { setValue } = useFormContext();
  const writeMode = useWatch({ name: 'mcp_permissions.write_mode' });
  const role = useWatch({ name: 'role' });
  const record = useRecordContext();
  const hasDbAccess = record ? record.has_db_access : undefined;
  const isApprover = MCP_APPROVER_ROLES.includes(Number(role));

  useEffect(() => {
    if (writeMode === MCP_WRITE_MODES.FULL) {
      setValue('mcp_permissions.write_tables', tables, { shouldDirty: true });
    } else if (writeMode === MCP_WRITE_MODES.NONE) {
      setValue('mcp_permissions.write_tables', [], { shouldDirty: true });
    }
  }, [writeMode, tables, setValue]);

  useEffect(() => {
    if (!isApprover) {
      setValue('mcp_permissions.can_approve', false, { shouldDirty: true });
    }
  }, [isApprover, setValue]);

  return (
    <>
      {hasDbAccess !== true && (
        <p>This user has no DB access; MCP permissions apply once it is on.</p>
      )}
      <RadioButtonGroupInput
        source="mcp_permissions.write_mode"
        label="Write mode"
        choices={MCP_WRITE_MODE_CHOICES}
        defaultValue={MCP_WRITE_MODES.NONE}
        row={false}
      />
      {writeMode === MCP_WRITE_MODES.SELECTED && (
        <CheckboxGroupInput
          row={false}
          label="Settings tables"
          source="mcp_permissions.write_tables"
          choices={tables.map((t) => ({ id: t, name: t }))}
        />
      )}
      {writeMode === MCP_WRITE_MODES.FULL && (
        <>
          <p>All settings tables:</p>
          <p>{tables.join(', ')}</p>
        </>
      )}
      <BooleanInput
        source="mcp_permissions.can_propose"
        label="Google Ads actions: may propose"
        defaultValue={false}
      />
      {isApprover ? (
        <BooleanInput
          source="mcp_permissions.can_approve"
          label="Google Ads actions: may approve and reject through the connector"
          defaultValue={false}
        />
      ) : (
        <p>Approve and reject are available to Admin and Media Manager roles only.</p>
      )}
      <p>
        Delete is never granted. Data tables cannot be written. Every write through the connector is logged in Activity Log under the user's name.
      </p>
    </>
  );
};
